import { Component, OnInit, Input } from '@angular/core';
import { trigger, style, transition, animate, group } from '@angular/animations';
import { Strings } from '../../../common/language/strings';
import { res } from '../../../common/language/text/res';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css'],
  animations: [
    trigger('itemAnim', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate(1000)
      ]),
      transition(':leave', [
        style({ opacity: 1, height: '*' }),
        animate(1000, style({ opacity: 0, height: 0}))
      ])
    ])
  ]
})
export class LoaderComponent implements OnInit {

  @Input() show:boolean;
  @Input() msg: string;
  @Input() hideH: boolean;

  title = ''

  constructor(
    public strings : Strings
  ) { 
    
    this.hideH = true;

  }

  ngOnInit() {
    this.title = this.strings.GetText(res.Loading);
    if(this.msg == null || this.msg == ""){this.msg = this.title}
  }

}
